if(!customElements.get('accordion-item')) {
  class AccordionItem extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      const summary = this.querySelector("summary");
  
      summary.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeExpandedAccordions();
        this.toggle();
      });
  
      if (this.dataset.open === "true") {
        this.open(this);
      }
    }
  
    closeExpandedAccordions() {
      this.parentElement.querySelectorAll("accordion-item").forEach((item) => {
        const details = item.querySelector("details");
        if (details.open) {
          this.close(item);
        }
      });
    }
  
    toggle() {
      const details = this.querySelector("details");
  
      if (details.open) {
        this.close(this);
      } else {
        this.open(this);
      }
    }
  
    close(item) {
      const icon = item.querySelector("svg");
      const details = item.querySelector("details");
      const content = item.querySelector(".content");
  
      content.style.maxHeight = `${content.scrollHeight}px`;
      content.getBoundingClientRect();
      icon.style.transform = "rotate(0deg)";
      content.style.maxHeight = "0px";
      setTimeout(() => {
        details.open = false;
      }, 300);
    }
  
    getHeight(el) {
      const clone = el.cloneNode(true);
      clone.style.height = "auto";
      clone.style.visibility = "hidden";
      clone.style.position = "absolute";
      clone.style.top = "-9999px";
      document.body.appendChild(clone);
      const height = clone.scrollHeight;
      document.body.removeChild(clone);
      return height;
    }
  
    open(item) {
      const icon = item.querySelector("svg");
      const details = item.querySelector("details");
      const content = item.querySelector(".content");
  
      details.open = true;
      content.style.maxHeight = "none";
      const contentHeight = content.scrollHeight;
      content.style.maxHeight = "0px";
      icon.style.transform = "rotate(180deg)";
  
      content.getBoundingClientRect();
      content.style.maxHeight = `${contentHeight}px`;
    }
  }
    
  customElements.define("accordion-item", AccordionItem);
}
